import React, { useEffect, useRef } from "react";
import leafIcon from "../../../../../assets/images/Mini-Game/reel-leaf.png";
import addSlot from "../../../../../assets/images/Mini-Game/reel-add-slot.png";
import bidIcon from "../../../../../assets/images/Mini-Game/reel-bid.png";
import puzzleIcon from "../../../../../assets/images/Mini-Game/reel-puzzle.png";
import SlotCounter from "react-slot-counter";
import styled from "styled-components";
import {
  ID_GIFT_PLAY_LOTO,
  useNewYear2025Theme,
  useThadingyutTheme,
  // IS_EVENT_THADINGYUT_2025_THEME,
} from "../../../../../helper/const";

const dummyCharacterCountTime = 6;
const durationTime = 4;
export default function LotoReel({ isStart = false, dataCongratesApi = {}, duration = 5 }) {
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();
  const slotRef = useRef(null);

  useEffect(() => {
    if (isStart && slotRef.current) {
      slotRef.current.startAnimation();
    } else {
      // slotRef.current.stopAnimation();
    }
  }, [isStart]);

  const option = [
    <img className='item-1 img-container' src={leafIcon} alt='' />,
    <img className='item-2 img-container' src={puzzleIcon} alt='' />,
    <img className='item-3 img-container' src={bidIcon} alt='' />,
    <img className='item-3 img-container' src={addSlot} alt='' />,
  ];

  let gift = null;
  if (+dataCongratesApi.id === ID_GIFT_PLAY_LOTO.good_luck) {
    gift = leafIcon;
  }
  if (+dataCongratesApi.id === ID_GIFT_PLAY_LOTO.add_spin) {
    gift = addSlot;
  }
  if (+dataCongratesApi.id === ID_GIFT_PLAY_LOTO.bid_free) {
    gift = bidIcon;
  }
  if (+dataCongratesApi.id === ID_GIFT_PLAY_LOTO.puzzle_piece) {
    gift = puzzleIcon;
  }

  return (
    <Container
      className={`${IS_EVENT_THADINGYUT_2025_THEME ? "thadingyut-theme" : ""} ${
        IS_EVENT_NEW_YEAR_2025_THEME ? "new-year-25-theme" : ""
      }`}
    >
      {/* <SlotCounter
        startValue={[
          <div className='container-img__mini-game__2025'>
            <img
              className='item-2 img-container'
              src={gift || puzzleIcon}
              alt=''
            />
          </div>,
        ]}
        value={[
          <div className='container-img__mini-game__2025'>
            <img
              className='item-4 img-container'
              src={gift || puzzleIcon}
              alt=''
            />
          </div>,
        ]}
        dummyCharacters={option}
        dummyCharacterCount={dummyCharacterCountTime}
        duration={duration}
      />

      <SlotCounter
        value={[
          <div className='container-img__mini-game__2025'>
            <img
              className='item-5 img-container'
              src={gift || bidIcon}
              alt=''
            />
          </div>,
        ]}
        startValue={[
          <div className='container-img__mini-game__2025'>
            <img className='item-2 img-container' src={bidIcon} alt='' />
          </div>,
        ]}
        dummyCharacters={option}
        dummyCharacterCount={dummyCharacterCountTime}
        duration={duration}
      />
      <SlotCounter
        startValue={[
          <div className='container-img__mini-game__2025'>
            <img className='item-2 img-container' src={addSlot} alt='' />
          </div>,
        ]}
        value={[
          <div className='container-img__mini-game__2025'>
            <img
              className='item-6 img-container'
              src={gift || addSlot}
              alt=''
            />
          </div>,
        ]}
        dummyCharacters={option}
        dummyCharacterCount={dummyCharacterCountTime}
        duration={duration}
      /> */}

      <SlotCounter
        ref={slotRef}
        startValueOnce
        autoAnimationStart={false}

        startValue={[
          <div className='container-img__mini-game__2025'>
            <img
              className='item-2 img-container'
              src={gift || puzzleIcon}
              alt=''
            />
          </div>,
          <div className='container-img__mini-game__2025'>
            <img className='item-2 img-container' src={gift || addSlot} alt='' />
          </div>,
          <div className='container-img__mini-game__2025'>
            <img className='item-2 img-container' src={gift || bidIcon} alt='' />
          </div>,
        ]}
        value={[
          <div className='container-img__mini-game__2025'>
            <img
              className='item-6 img-container'
              src={gift || addSlot}
              alt=''
            />
          </div>,
          <div className='container-img__mini-game__2025'>
            <img
              className='item-5 img-container'
              src={gift || bidIcon}
              alt=''
            />
          </div>,
          <div className='container-img__mini-game__2025'>
            <img
              className='item-4 img-container'
              src={gift || puzzleIcon}
              alt=''
            />
          </div>,
        ]}
        dummyCharacters={option}
        dummyCharacterCount={dummyCharacterCountTime}
        duration={duration}
      />
    </Container>
  );
}

const Container = styled.span`
  display: block;

  .index-module_slot_wrap__ZT-DX {
    position: relative;
    /* left: -20px; */
    /* top: 8px; */
    .slot-counter-item:first-child {
      left: 0%;
      transform: translateX(-75%)
    }
    .slot-counter-item {
      transform: translateX(-10%);
    }
    .slot-counter-item:last-child {
      right: 0%;
      transform: translateX(60%)
    }
  }

  .index-module_slot__DpPgW {
    position: relative;
  }

  .index-module_slot_wrap__ZT-DX:first-child {
    position: relative;
    /* left: -99px; */
  }

  .index-module_slot_wrap__ZT-DX:last-child {
    position: relative;
    /* left: 57px; */
  }

  .index-module_slot__DpPgW,
  .index-module_num__j6XH3 {
    height: 160px;
    position: relative;
    top: 18px;
  }

  .img-container {
    position: relative;
    top: 18px;
    display: flex;
    justify-content: center;
    margin: 0 auto;
  }

  .index-module_num__j6XH3 {
    width: 115px;
  }

  .img-container {
    width: 95px;
    top: 0px;
  }

  .container-img__mini-game__2025 {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    text-align: center;
    width: 80px;
    height: 92px;
  }

  .index-module_slot_wrap__ZT-DX {
    .slot-counter-item:first-child {
      left: 0%;
      transform: translateX(-50%)
    }
    .slot-counter-item:last-child {
      right: 0%;
      transform: translateX(35%)
    }
  }

  .index-module_slot_wrap__ZT-DX:first-child {
    /* left: -65px; */
  }

  .index-module_slot_wrap__ZT-DX:last-child {
    /* left: 32px; */
  }

  .index-module_slot__DpPgW,
  .index-module_num__j6XH3 {
    height: 128px;
    position: relative;
    top: 20px;
  }

  .index-module_slot_wrap__ZT-DX:nth-child(2) {
    .index-module_slot__DpPgW {
    }

    /* .index-module_num__j6XH3{
      top: 10px;
    } */
  }
  @media (max-width: 1400px) {
  }

  @media (max-width: 1200px) {
    .img-container {
      width: 80px;
      /* top: -4px; */
    }
    .index-module_slot_wrap__ZT-DX {
      position: relative;
      /* left: -8px; */
    }

    .index-module_slot__DpPgW,
    .index-module_num__j6XH3 {
      height: 108px;
      top: 19px;
      /* left: -4px; */
    }

    .container-img__mini-game__2025 {
      width: 72px;
      height: 85px;
      position: relative;
      top: -5px;
    }

    .index-module_slot_wrap__ZT-DX {
      .slot-counter-item:first-child {
        left: 0%;
        transform: translateX(-27%)
      }
      .slot-counter-item {
        transform: translateX(-5%);
      }
      .slot-counter-item:last-child {
        right: 0%;
        transform: translateX(17%)
      }
    }

    .index-module_slot_wrap__ZT-DX:first-child {
      /* left: -33px; */
    }
    .index-module_slot_wrap__ZT-DX:last-child {
      /* left: 19px; */
    }
  }

  @media (max-width: 1075px) {
    .index-module_slot_wrap__ZT-DX {
      position: relative;
      /* left: -8px; */
    }
    .index-module_slot_wrap__ZT-DX:first-child {
      /* left: -44px; */
    }
    .index-module_slot_wrap__ZT-DX:last-child {
      /* left: 34px; */
    }
    .index-module_slot__DpPgW,
    .index-module_num__j6XH3 {
      height: 96px;
      top: 16px;
    }

    .index-module_slot_wrap__ZT-DX {
    
      .slot-counter-item:first-child {
        left: 0%;
        transform: translateX(-50%)
      }
      .slot-counter-item:last-child {
        right: 0%;
        transform: translateX(40%)
      }
    }

    .index-module_num__j6XH3 {
      width: 90px;
    }

    .img-container {
      width: 56px !important;
    }
  }

  @media (max-width: 992px) {
    .index-module_slot_wrap__ZT-DX:first-child {
      /* left: -59px; */
    }
    .index-module_slot_wrap__ZT-DX:last-child {
      /* left: 43px; */
    }

    .index-module_slot_wrap__ZT-DX {
      top: -5px;
      .slot-counter-item:first-child {
        left: 0%;
        transform: translateX(-60%)
      }
      .slot-counter-item:last-child {
        right: 0%;
        transform: translateX(50%)
      }
    }
  }

  @media (max-width: 768px) {
    .index-module_slot_wrap__ZT-DX:first-child {
      /* left: -44px; */
    }
    .index-module_slot_wrap__ZT-DX:last-child {
      /* left: 34px; */
    }

    .index-module_slot__DpPgW,
    .eGvPuB .index-module_num__j6XH3 {
      top: 18px;
    }

    .index-module_slot_wrap__ZT-DX {
      .slot-counter-item:first-child {
        left: 0%;
        transform: translateX(-50%)
      }
      .slot-counter-item:last-child {
        right: 0%;
        transform: translateX(40%)
      }
    }
  }

  @media (max-width: 576px) {
    .img-container {
      top: 0px;
      width: auto !important;
      height: 45px;
    }
    .index-module_slot_wrap__ZT-DX {
      position: relative;
      /* left: -5px; */
    }
    .index-module_slot_wrap__ZT-DX:first-child {
      /* left: -35px; */
    }
    .index-module_slot_wrap__ZT-DX:last-child {
      /* left: 30px; */
    }
    .index-module_slot__DpPgW,
    .index-module_num__j6XH3 {
      height: 80px;
      top: 7.5px;
      /* left: -4px; */
    }

    .container-img__mini-game__2025 {
      height: 80px;
      /* top: -6px; */
    }

    .index-module_num__j6XH3 {
      width: 76px;
    }
  }

  @media (max-width: 492px) {
    .img-container {
      width: auto;
      /* top: -10px;*/
      height: 40px;
    }

    .index-module_slot__DpPgW,
    .index-module_num__j6XH3 {
      /* left: -2px; */
      /* height: 79px; */
      top: 4px;
    }

    .index-module_slot_wrap__ZT-DX {
      .slot-counter-item:first-child {
        left: 0%;
        transform: translateX(-20%)
      }
      .slot-counter-item:last-child {
        right: 0%;
        transform: translateX(10%)
      }
    }


    .index-module_slot_wrap__ZT-DX {
      top: 3.5px;
    }
    .index-module_slot_wrap__ZT-DX:first-child {
      /* left: -14.5px; */
    }

    .index-module_slot_wrap__ZT-DX:last-child {
      /* left: 5.5px; */
    }

    .container-img__mini-game__2025 {
      height: 79px;
    }
  }

  @media (max-width: 412px) {
    .img-container {
      width: auto;
      top: 12px;
      height: 35px;
    }
    .index-module_slot_wrap__ZT-DX:first-child {
      /* left: -8px; */
    }

    .index-module_slot_wrap__ZT-DX {
      .slot-counter-item:first-child {
        left: 0%;
        transform: translateX(-10%)
      }
      .slot-counter-item:last-child {
        right: 0%;
        transform: translateX(5%)
      }
    }

    .index-module_slot__DpPgW,
    .index-module_num__j6XH3 {
      height: 63px;
      top: 10px;
    }

    .index-module_slot_wrap__ZT-DX:last-child {
      /* left: 1px; */
    }

    .container-img__mini-game__2025 {
      top: -38px !important;
    }

    .img-container {
      top: 19px;
    }
  }

  @media (max-width: 375px) {
    .img-container {
      width: auto;
      top: 12px;
      height: 30px;
    }
    .index-module_slot_wrap__ZT-DX:first-child {
      /* left: 0px; */
    }

    .index-module_slot_wrap__ZT-DX {
      .slot-counter-item:first-child {
        left: 0%;
        transform: translateX(2%)
      }
      .slot-counter-item:last-child {
        right: 0%;
        transform: translateX(-7%)
      }
    }

    .index-module_slot__DpPgW,
    .index-module_num__j6XH3 {
      height: 60px;
      top: 10.5px;
    }

    .container-img__mini-game__2025 {
      top: -41px !important;
    }

    .index-module_slot_wrap__ZT-DX:last-child {
      /* left: -6px; */
    }

    .img-container {
      top: 19px;
    }
  }

  &.thadingyut-theme {
    .index-module_slot_wrap__ZT-DX {
      position: relative;
      /* left: -13px; */
    }

    .index-module_slot_wrap__ZT-DX:first-child {
      /* left: -80px; */
    }

    .index-module_slot_wrap__ZT-DX:last-child {
      position: relative;
      /* left: 63px; */
    }

    .index-module_slot__DpPgW,
    .index-module_num__j6XH3 {
      top: 12px;
    }

    .index-module_slot__DpPgW,
    .index-module_num__j6XH3 {
      top: 16px;
    }
    .index-module_slot_wrap__ZT-DX:first-child {
      /* left: -51px; */
    }

    .index-module_slot_wrap__ZT-DX:last-child {
      /* left: 32px; */
    }
    @media (max-width: 1400px) {
    }

    @media (max-width: 1200px) {
      .index-module_slot_wrap__ZT-DX:first-child {
        /* left: -21px; */
      }
      .index-module_slot_wrap__ZT-DX:last-child {
        /* left: 19px; */
      }
      .index-module_slot_wrap__ZT-DX {
        position: relative;
        /* left: -8px; */
      }

      .index-module_slot__DpPgW,
      .index-module_num__j6XH3 {
        top: 19px;
        /* left: -4px; */
      }
    }

    @media (max-width: 1075px) {
      .index-module_slot_wrap__ZT-DX:first-child {
        /* left: -35px; */
      }
      .index-module_slot_wrap__ZT-DX:last-child {
        /* left: 34px; */
      }
      .index-module_slot__DpPgW,
      .index-module_num__j6XH3 {
        height: 96px;
        top: 13px;
      }
      .index-module_slot_wrap__ZT-DX {
        /* left: -4px; */
      }
    }

    @media (max-width: 992px) {
      .index-module_slot_wrap__ZT-DX:first-child {
        /* left: -49px; */
      }
      .index-module_slot_wrap__ZT-DX:last-child {
        /* left: 43px; */
      }
      .index-module_slot_wrap__ZT-DX {
        /* left: 0; */
      }
    }

    @media (max-width: 768px) {
      .index-module_slot__DpPgW,
      .eGvPuB .index-module_num__j6XH3 {
        top: 13px;
      }
      .index-module_slot_wrap__ZT-DX:first-child {
        /* left: -33px; */
      }
      .index-module_slot_wrap__ZT-DX:last-child {
        /* left: 34px; */
      }
      .index-module_slot_wrap__ZT-DX {
        /* left: 0; */
      }
    }

    @media (max-width: 576px) {
      .index-module_slot_wrap__ZT-DX:first-child {
        /* left: -27px; */
      }
      .index-module_slot_wrap__ZT-DX:last-child {
        /* left: 30px; */
      }
      .index-module_slot_wrap__ZT-DX {
        /* left: 0; */
      }
      .index-module_slot__DpPgW,
      .index-module_num__j6XH3 {
        height: 80px;
        top: 3.5px;
        /* left: -4px; */
      }
    }

    @media (max-width: 492px) {
      .index-module_slot__DpPgW,
      .index-module_num__j6XH3 {
        left: -2px;
        height: 79px;
        top: 4px;
      }

      .index-module_slot_wrap__ZT-DX {
        top: 3.5px;
      }
      .index-module_slot_wrap__ZT-DX:first-child {
        /* left: -7.5px; */
      }

      .index-module_slot_wrap__ZT-DX:last-child {
        /* left: 5.5px; */
      }

      .container-img__mini-game__2025 {
        height: 79px;
      }
    }

    @media (max-width: 412px) {
      .img-container {
        width: auto;
        top: 12px;
        height: 35px;
      }
      .index-module_slot_wrap__ZT-DX:first-child {
        /* left: -2px; */
      }

      .index-module_slot__DpPgW,
      .index-module_num__j6XH3 {
        height: 63px;
        top: 10px;
      }

      .index-module_slot_wrap__ZT-DX:last-child {
        /* left: 1px; */
      }

      .container-img__mini-game__2025 {
        top: -38px !important;
      }

      .img-container {
        top: 19px;
      }
    }

    @media (max-width: 375px) {
      .img-container {
        width: auto;
        top: 12px;
        height: 30px;
      }
      .index-module_slot_wrap__ZT-DX:first-child {
        /* left: 5px; */
      }

      .index-module_slot__DpPgW,
      .index-module_num__j6XH3 {
        height: 60px;
        top: 10.5px;
      }

      .container-img__mini-game__2025 {
        top: -41px !important;
      }

      .index-module_slot_wrap__ZT-DX:last-child {
        /* left: -6px; */
      }

      .img-container {
        top: 19px;
      }
    }
  }

  &.new-year-25-theme {
    .index-module_slot_wrap__ZT-DX {
      position: relative;
      /* left: -13px; */
      .slot-counter-item {
        transform: translateX(0);
      }
      .slot-counter-item:first-child {
        left: 0%;
        transform: translateX(-60%)
      }
      .slot-counter-item:last-child {
        right: 0%;
        transform: translateX(60%)
      }
    }

    .index-module_slot_wrap__ZT-DX:first-child {
      /* left: -85px; */
    }

    .index-module_slot_wrap__ZT-DX:last-child {
      position: relative;
      /* left: 60px; */
    }

    .index-module_slot_wrap__ZT-DX:first-child {
      /* left: -56px; */
    }

    .index-module_slot_wrap__ZT-DX:last-child {
      /* left: 32px; */
    }

    .index-module_slot_wrap__ZT-DX {
      position: relative;
      /* left: -13px; */
      .slot-counter-item {
        transform: translateX(0);
      }
      .slot-counter-item:first-child {
        left: 0%;
        transform: translateX(-40%)
      }
      .slot-counter-item:last-child {
        right: 0%;
        transform: translateX(40%)
      }
    }
    @media (max-width: 1400px) {
    }

    @media (max-width: 1200px) {
      .index-module_slot_wrap__ZT-DX:first-child {
        /* left: -25px; */
      }
      .index-module_slot_wrap__ZT-DX:last-child {
        /* left: 20px; */
      }
      .index-module_slot_wrap__ZT-DX {
        position: relative;
        /* left: -8px; */
        .slot-counter-item {
          transform: translateX(0);
        }
        .slot-counter-item:first-child {
          left: 0%;
          transform: translateX(-20%)
        }
        .slot-counter-item:last-child {
          right: 0%;
          transform: translateX(20%)
        }
      }
    }

    @media (max-width: 1075px) {
      .index-module_slot_wrap__ZT-DX:first-child {
        /* left: -36px; */
      }
      .index-module_slot_wrap__ZT-DX:last-child {
        /* left: 36px; */
      }
      .index-module_slot_wrap__ZT-DX {
        /* left: -4px; */
        .slot-counter-item {
          transform: translateX(0);
        }
        .slot-counter-item:first-child {
          left: 0%;
          transform: translateX(-35%)
        }
        .slot-counter-item:last-child {
          right: 0%;
          transform: translateX(35%)
        }
      }
    }

    @media (max-width: 992px) {
      .index-module_slot_wrap__ZT-DX:first-child {
        /* left: -50px; */
      }
      .index-module_slot_wrap__ZT-DX:last-child {
        /* left: 42px; */
      }
      .index-module_slot_wrap__ZT-DX {
        /* left: 0; */

        .slot-counter-item {
          transform: translateX(0);
        }
        .slot-counter-item:first-child {
          left: 0%;
          transform: translateX(-50%)
        }
        .slot-counter-item:last-child {
          right: 0%;
          transform: translateX(50%)
        }
      }
    }

    @media (max-width: 768px) {
      .index-module_slot_wrap__ZT-DX:first-child {
        /* left: -35px; */
      }
      .index-module_slot_wrap__ZT-DX:last-child {
        /* left: 35px; */
      }
      .index-module_slot_wrap__ZT-DX {
        /* left: 0; */
        .slot-counter-item {
          transform: translateX(0);
        }
        .slot-counter-item:first-child {
          left: 0%;
          transform: translateX(-40%)
        }
        .slot-counter-item:last-child {
          right: 0%;
          transform: translateX(40%)
        }
      }
    }

    @media (max-width: 576px) {
      .index-module_slot_wrap__ZT-DX:first-child {
        /* left: -28px; */
      }
      .index-module_slot_wrap__ZT-DX:last-child {
        /* left: 30px; */
      }
      .index-module_slot_wrap__ZT-DX {
        /* left: 0; */
        top: 0;
      }
    }

    @media (max-width: 492px) {
      .index-module_slot_wrap__ZT-DX {
        top: 7.5px;
        .slot-counter-item {
          transform: translateX(0);
        }
        .slot-counter-item:first-child {
          left: 0%;
          transform: translateX(-10%)
        }
        .slot-counter-item:last-child {
          right: 0%;
          transform: translateX(10%)
        }
      }
      .index-module_slot_wrap__ZT-DX:first-child {
        /* left: -9.5px; */
      }

      .index-module_slot_wrap__ZT-DX:last-child {
        /* left: 5.5px; */
      }

      .container-img__mini-game__2025 {
        height: 79px;
      }
    }

    @media (max-width: 412px) {
      .index-module_slot_wrap__ZT-DX:first-child {
        /* left: -3px; */
      }

      .index-module_slot_wrap__ZT-DX:last-child {
        /* left: 2px; */
      }

      .index-module_slot_wrap__ZT-DX {
        top: 7.5px;
        .slot-counter-item {
          transform: translateX(0);
        }
        .slot-counter-item:first-child {
          left: 0%;
          transform: translateX(-5%)
        }
        .slot-counter-item:last-child {
          right: 0%;
          transform: translateX(5%)
        }
      }

      .container-img__mini-game__2025 {
        top: -38px !important;
      }

      .img-container {
        top: 19px;
      }
    }

    @media (max-width: 375px) {
      .index-module_slot_wrap__ZT-DX:first-child {
        /* left: 6px; */
      }

      .container-img__mini-game__2025 {
        top: -41px !important;
      }

      .index-module_slot_wrap__ZT-DX:last-child {
        /* left: -4px; */
      }

      .index-module_slot_wrap__ZT-DX {
        top: 7.5px;
        .slot-counter-item {
          transform: translateX(0);
        }
        .slot-counter-item:first-child {
          left: 0%;
          transform: translateX(5%)
        }
        .slot-counter-item:last-child {
          right: 0%;
          transform: translateX(-5%)
        }
      }

      .img-container {
        top: 19px;
      }
    }
  }
`;
